import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_HISTORY_MODELS } from './constants';
import {
  AddHistoryModelsSuccess,
  AddHistoryModelsError,
  AddHistoryModelsDataActionTypes,
  AddHistoryModelsState,
} from './types';

const initialState: AddHistoryModelsState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AddHistoryModelsDataActionTypes,
  ): AddHistoryModelsState => {
    switch (action.type) {
      case ADD_HISTORY_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_HISTORY_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddHistoryModelsSuccess).payload;
        break;
      }
      case ADD_HISTORY_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddHistoryModelsError).error;
        break;
      }
      case ADD_HISTORY_MODELS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
